import axios from "axios";
import { AdresseIP } from '../AdresseIP';

export class RetraitService {
  constructor() {
    this.adresse = new AdresseIP()
    this.backendUrl ='/service/api/diplome/authentification'
    this.API_URL = this.adresse.getAdresseIP()+this.backendUrl
  }

  /*getInscriptionsEtudiant = async (ine) => {
    const response = await axios.get(`${this.API_URL}/etudiant-inscriptions/${ine}`);
    return response.data;
  };*/

  getInscriptionsEtudiant(ine){
    return axios.get(`${this.API_URL}/etudiant-inscriptions/${ine}`).then(res => res.data)
    
  };

  listeInscription(idDepartement, idParcours, idNiveau, idAnnee){
    return axios.get(`${this.API_URL}/liste-inscription?idDepartement=${idDepartement}&idParcours=${idParcours}&idNiveau=${idNiveau}&idAnneeAcademique=${idAnnee}`).then(res => res.data)
  }

  faireRetait(payload) {
    return axios.post(`${this.API_URL}/retrait-diplome`,payload)
                    .then(res => res.data);
  }

  getRetrait(idInscription){
    return axios.get(`${this.API_URL}/retrait-diplome/${idInscription}`).then(res => res.data)
    
  };

  listeRetrait(idDepartement, idParcours, idNiveau, idAnnee){
    return axios.get(`${this.API_URL}/liste-retrait-diplome?idDepartement=${idDepartement}&idParcours=${idParcours}&idNiveau=${idNiveau}&idAnneeAcademique=${idAnnee}`).then(res => res.data)
  }

  getNbInscrisUniv(idUniversite){
    return axios.get(`${this.API_URL}/inscription-stats-agent?idUniversite=${idUniversite}`).then(res => res.data)
  }
   getNbInscris(){
    return axios.get(`${this.API_URL}/inscription-stats-admin`).then(res => res.data)
  }
  

  /*faireRetait = async (payload) => {
    try {
      const response = await axios.post(`${this.API_URL}/retrait-diplome`, {
        payload: payload,
    });
    return response.data;
    } catch (error) {
      console.error("Erreur lors du rétrait :", error);
      throw error;
    }
  }*/

}